<template>
    <el-drawer class="drawer" ref="drawer" :visible.sync="drawer" :direction="direction" :destroy-on-close="true"  @opened="getlist" :size="size">
        <div class="title-box" slot="title">
            <div class="butn-status" :class="{'butn-status-red': sourceData.status == 1,'butn-status-blue' : sourceData.status == 2, 'butn-status-purple' : sourceData.status == 3, 'butn-status-yellow' : sourceData.status == 4, 'butn-status-green': sourceData.status == 5, 'butn-status-gray': sourceData.status == -1}">{{ sourceData.status | statusFilter}}</div>
            <span class="title">{{sourceData.title}}</span>
        </div>

        <!-- 切换 -->
        <el-radio-group v-model="activeName">
            <el-radio-button label="1" v-if="accessPoint['audit:read']">审核信息</el-radio-button>
            <el-radio-button label="2" v-if="accessPoint['uploadfile:read'] &&sourceData.status !== -1" >上传完稿文件(乙方)</el-radio-button>
            <el-radio-button label="3" v-if="accessPoint['checkfile:read'] &&sourceData.status !== -1" >验收完稿文件</el-radio-button>
            <el-radio-button label="4" v-if="accessPoint['overfile:read'] &&sourceData.status !== -1" >结算/验收(乙方)</el-radio-button>
        </el-radio-group>

        <!-- 主内容 -->
        <main-pane ref="pane" :activeName="activeName" :dataSource='sourceData' :rowId='sourceData.id'></main-pane>

    </el-drawer>
</template>

<script>
import mainPane from './mainPane.vue'
import {outsource_flowDetail} from "@File~/api/outsourcing";
export default {
  components: { mainPane },
    props: {
        // 弹框大小
        size: {
            type: String,
            default: '1080px'
        },
    },
    filters: {
        // 状态
        statusFilter(status) {
            // const statusMap = {
            //     0: '待审批',
            //     1: '进行中',
            //     2: '待验收',
            //     3: '待结算',
            //     4: '已完成',
            //     5: '已拒绝',
            // }
            let statuStr = '';
            switch(status){
                case 1:
                statuStr = '待审批';
                break;
                case 2:
                statuStr = '进行中';
                break;
                case 3:
                statuStr = '待验收';
                break;
                case 4:
                statuStr = '待结算';
                break;
                case 5:
                statuStr = '已完成';
                break;
                case -1:
                statuStr = '已拒绝';
                break;
            }
            // return statusMap[status];
            return statuStr;
        },
    },
    data() {
        return {
            drawer: false, // 弹窗
            direction: 'rtl',
            sourceData: {}, // 数据源
            activeName: '1',
            accessPoint: this.$store.getters.accessPoint, //权限点

        }
    },

    methods: {
        // 初始化
        init(row) {
            this.activeName = 1
            this.drawer = true
            this.sourceData = row

            // outsource_flowDetail(row.id).then((response) => {
            //     if (response.code == 1) {
            //         this.sourceData = response.data;
            //     }
            // });
        },

        // 获取数据列表
        getlist() {
            
        },
        
    }
}
</script>

<style lang="scss" scoped>
    .drawer{
        ::v-deep .el-drawer__header{
            margin-bottom: 0;
            padding: 0 32px;
            height: 56px;
            border-bottom: 1px solid  #E5E5E5;
            box-shadow: 0px -1px 0px 0px #E5E5E5;
        }
        ::v-deep .el-drawer__close-btn{
            font-size: 24px;
            color: #999999;
        }

        .title-box{
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: center;

            .butn-status{
                padding: 4px 8px;
                border-radius: 4px;
                margin-right: 12px;
                font-size: 14px;
                color: #FFFFFF;
            }
            .butn-status-red{
                background: #FB6C75;
            }
            .butn-status-blue{
                background:#439DE2;
            }
            .butn-status-purple{
                background: #876FFF
            }
            .butn-status-yellow{
                background: #FFA356
            }
            .butn-status-green{
                background: #0ED27F
            }
            .butn-status-gray{
                background: #CCCCCC
            }
            .title{
                font-size: 16px;
                color: #333333;
                line-height: 22px;
            }
        }

        ::v-deep.el-drawer__body{
            background: #F5F5F5;
        }

        ::v-deep .el-radio-group{
            width: 100%;
            padding: 0 73px;
            height: 54px;
            line-height: 54px;
            background: #FFFFFF;
        }

        ::v-deep.el-radio-button__inner{
            padding: 0 65px;
            font-size: 16px;
            font-weight: 500;
            color: #999999;
            border:0;
            position: relative;

            &::after{
                content: '';
                position:absolute;
                left: 50%;
                bottom: -20px;
                transform:translateX(-50%);
                width: 80px;
                height: 4px;
            }
        }

        ::v-deep.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            color: #333333;
            background-color: transparent;
            box-shadow:none;
            &::after{
                background: #3A89FF;
            }
        }
    }

    ::v-deep :focus {
        outline: 0;
    }
</style>